import { useState } from 'react';
import {
  InlineInputWrapper,
  InlineInputWrapperProps,
} from '../inline-input-wrapper';
import { FileInput } from 'src/modules/shared/components/atoms/inputs/file-input';

interface InlineFileInputProps
  extends Omit<InlineInputWrapperProps, 'children'> {
  placeholder?: string;
  onFileChange?: (file: File) => Promise<string>;
}

export const InlineFileInput: React.FC<InlineFileInputProps> = ({
  placeholder,
  onFileChange,
  variant = 'primary',
  size = 'sm',
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = async (file: File) => {
    if (!onFileChange) return;

    setIsLoading(true);

    try {
      const fileValue = await onFileChange(file);
      await props.onSave(fileValue);
    } catch (error) {
      if (props.onError && error instanceof Error) {
        props.onError(error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <InlineInputWrapper {...props} size={size} disableCopy={true}>
      {({ value, disabled, loading }) => (
        <div className="w-full flex gap-2 items-center">
          <FileInput
            value={value}
            onChange={handleFileChange}
            disabled={disabled}
            loading={loading || isLoading}
            placeholder={placeholder}
            variant={variant}
            size={size}
          />
        </div>
      )}
    </InlineInputWrapper>
  );
};
